import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Mail } from 'lucide-react';
import useSEO from '@/hooks/useSEO';

const PasswordSupport = () => {
  useSEO({ title: 'Password support — EpisodeKit', path: '/password-support', index: false });
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="password-support-page">
      <div className="noise-overlay" />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center justify-center mb-8">
            <img 
              src="/logo-full.png" 
              alt="EpisodeKit" 
              className="h-10 w-auto"
            />
          </Link>
        </div>

        <div className="card-base text-center">
          <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Mail className="w-8 h-8 text-primary" />
          </div>
          
          <h1 className="text-2xl font-unbounded font-bold mb-4">Password Reset</h1>
          
          <p className="text-neutral-400 mb-6">
            Password reset is currently handled manually.<br />
            Please contact our support team at:
          </p>
          
          <a 
            href="mailto:support@episodekit.net"
            className="block text-lg font-semibold text-primary hover:underline mb-6 select-all"
          >
            support@episodekit.net
          </a>
          
          <p className="text-neutral-500 text-sm mb-8">
            Include your account email so we can assist you faster.
          </p>
          
          <Link to="/login">
            <Button variant="outline" className="w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Sign In
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswordSupport;
